import { redirectIfNonCustomerMiddleware } from "~/components/_refactored/auth";

export default redirectIfNonCustomerMiddleware;
